function init_voir_aussi_slider() {
	if (Foundation.MediaQuery.current == "medium") {
		if ($("#voir_aussi .slick-list").length > 0) {
			$('#voir_aussi .content').slick('unslick');
		}
		$('#voir_aussi .content').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			// ///////// Conf pour arrow prev / next
			prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
			nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
			
		});

	} else if (Foundation.MediaQuery.current == "small") {
		if ($("#voir_aussi .slick-list").length > 0) {
			$('#voir_aussi .content').slick('unslick');
		}
		$('#voir_aussi .content').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			arrows: true,
			// ///////// Conf pour arrow prev / next
			prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
			nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
			responsive: [
				{
					breakpoint: 524,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	} else {
		if ($("#voir_aussi .slick-list").length > 0) {
			$('#voir_aussi .content').slick('unslick');
		}
	}
}



$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
  init_voir_aussi_slider();
  if ($("#voir_aussi .slick-list").length > 0) {$('#voir_aussi .content').slick('refresh');}
});

$(document).bind('_js_ready popin', function() {
	init_voir_aussi_slider(); 
});